import React, { useEffect } from "react";
import { Input, TextAreaInput } from "../../../Helpers/Input/Input";
import { Switch } from "antd";
import trans, { isRTL } from "../../../../utils";
import { InputSelect } from "../../../Helpers/Input/RefactoredInput";

export default function FormInf({
	collapsed,
	addForm,
	setDirection,
	direction,
}) {
	useEffect(() => {
		if (isRTL) setDirection(false);
	}, [isRTL]);
	const category = [
		{ label: "IR", value: "IR" },
		{ label: "MIR", value: "MIR" },
		{ label: "NCR", value: "NCR" },
		{ label: "SNAG", value: "SNAG" },
		{ label: "SUBMITTAL", value: "SUBMITTAL" },
	];
	return (
		<div dir={isRTL ? "rtl" : "ltr"}>
			<p
				style={{
					fontSize: 16,
					fontWeight: 600,
					textTransform: "capitalize",
					textAlign: isRTL ? "right" : "left",
				}}
			>
				{trans("form settings")}
			</p>
			<div
				className="w-100 mb-3"
				style={{ textAlign: isRTL ? "right" : "left" }}
			>
				<label className="form-label text-capitalize">
					{trans("form name")}
				</label>
				<Input
					placeholder={trans("Enter Form Name.")}
					id="name"
					name="name"
					onBlur={addForm.handleBlur}
					onChange={addForm.handleChange}
					errors={addForm.errors.name}
					touched={addForm.touched.name}
					value={addForm.values.name ? addForm.values.name : ""}
				/>
			</div>
			<div className="w-100" style={{ textAlign: isRTL ? "right" : "left" }}>
				<label className="form-label text-capitalize">
					{trans("form description")}
				</label>
				<TextAreaInput
					placeholder={trans("Enter Form Description.")}
					id="description"
					name="description"
					onBlur={addForm.handleBlur}
					onChange={addForm.handleChange}
					errors={addForm.errors.description}
					touched={addForm.touched.description}
					value={addForm.values.description || ""}
				/>
			</div>
			<div
				className="w-100 mt-3"
				style={{ textAlign: isRTL ? "right" : "left" }}
			>
				<InputSelect
					label="category"
					name="category"
					id="category"
					options={category?.map((i) => ({
						label: i.label,
						value: i.value,
					}))}
					placeholder={trans(`Select category`)}
					formstyle="form-input"
					onBlur={(e) => addForm.handleBlur(e)}
					onChange={(value) => addForm.setFieldValue("category", value)}
					value={addForm.values.category || ""}
					allowClear={false}
					touched={addForm.touched.category}
					errors={addForm.errors.category}
				/>
			</div>
			{/* {!isRTL && (
				<div className="w-100 d-flex align-items-center justify-content-between mt-3">
					<label className="form-label text-capitalize">RTL</label>
					<Switch size="small" onChange={() => setDirection(!direction)} />
				</div>
			)} */}
		</div>
	);
}
